import React from 'react';
import {bool, func, object} from 'prop-types';
import BasicModal from 'components/common/BasicModal';
import {platformMappings} from 'utils/DBUtils';
import {makeFormFactory} from "utils/helpers";
import DeleteStepsCheckbox from "./DeleteStepsCheckbox";
import config from "./deleteStepsFormConfig";

let deleteForm = makeFormFactory({
    'checkbox': DeleteStepsCheckbox
});

const DeleteStepsForm = deleteForm(config);

const DeleteStepsModal = props => (
  <BasicModal
    header={`Select Steps to Delete - ${platformMappings[props.currentPlatform]}`}
    specialType='db-steps-modal primary-modal'
    dimmer={'inverted'}
    modalSize='small'
    actions={[
      {
        label: 'Cancel',
        action: props.handleClose,
        isDisabled: false,
        displayType: 'menu-item'
      },
      {
        label: 'Delete Steps',
        action: props.submit,
        isDisabled: false,
        displayType: 'button',
        primaryCheck: true
      }
    ]}
    open={props.modalOpen}
    onClose={props.handleClose}>
    <DeleteStepsForm onValueChanged={props.onValueChanged}
                     onValidationError={props.onValidationError}
                     errors={props.errors}
                     data={props.formData}/>
  </BasicModal>
);

DeleteStepsModal.propTypes = {
  formData: object.isRequired,
  onSaveData: func.isRequired,
  formValueChanged: func.isRequired,

  handleClose: func.isRequired,
  modalOpen: bool.isRequired
};

export default DeleteStepsModal;



// WEBPACK FOOTER //
// ./public/pages/ViewAllPlatforms/DeleteSteps/DeleteStepsModal.jsx